import SidebarNav from '../sidebar/SidebarNav';
import SidebarItem, { NavCountBadgeUrgent } from '../sidebar/SidebarItem';

const SuperAdminSidebarNav = ({ sections, location, onNavigate, badgeCounts = {} }) => (
  <SidebarNav
    sections={sections}
    location={location}
    renderItem={(item, { isActive }) => {
      const Icon = item.icon;
      const count = badgeCounts[item.id];
      return (
        <SidebarItem
          key={item.id}
          as="a"
          icon={Icon}
          label={item.name}
          active={isActive}
          href={item.href}
          badge={count ? <NavCountBadgeUrgent count={count} /> : null}
          onClick={(e) => {
            e.preventDefault();
            onNavigate(item);
          }}
        />
      );
    }}
  />
);

export default SuperAdminSidebarNav;
